<template>
  <div id="app" v-bind:class="{ 'loggedIn': authenticated, 'login': !authenticated }">
    <div v-if="loading" class="loader">
      <spinner size="big"></spinner>
    </div>
    <router-view v-if="loading === false && ok"></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from 'vue-simple-spinner';

import auth from '@/utils/auth';

export default {
  name: 'app',
  components: {
    Spinner,
  },
  data() {
    return {
      ok: false,
    };
  },
  computed: {
    ...mapGetters([
      'error',
      'loading',
      'authenticated',
    ]),
  },
  beforeMount() {
    this.ok = auth.checkAuth(this);
  },
  watch: {
    // eslint-disable-next-line
    '$route'() {
      this.ok = auth.checkAuth(this);
    },
  },
};
</script>

<style lang="scss">
@import './assets/style/custom-bootstrap.scss';
@import '~bootstrap/scss/bootstrap';
@import './assets/style/fonts.css';
@import url('https://fonts.googleapis.com/css?family=Work+Sans:300,400,500,600');

body {
  background: #E6E7E8;
}
#app {
  font-family: 'Work Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding-top: 60px;

  &:after {
    content: "";
    opacity: 0;
    transition: opacity ease 1s;
    z-index: 0;
  }

  &.login {
    min-height: 100vh;
    padding-top: 0;

    &:after {
      position: absolute;
      opacity: 1;
      background-image: url('/static/img/bg-login.jpg');
      background-size: cover;
      top: 0;
      width: 100%;
      height: 100%;
      transition: opacity ease 2s;
    }
  }

  > div {
    position: relative;
    z-index: 1;
  }

  .loader {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .container, .container-fluid {
    &.content {
      margin-top: 1.5rem;
      margin-bottom: 1.5rem;
      background: #fff;
      padding: 1rem;
      border-radius: 5px;

      @media only screen and (min-width: 992px){
        padding: 2rem;
        margin-top: 3rem;
        margin-bottom: 3rem;
      }

      &.nobg {
        background: none;
        padding: 0;
      }
      &.no-vert-pad {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }
  .navbar + .container-fluid{
    &.content, &.settings-content {
      margin-left: 3rem;
      margin-right: 3rem;
      width: auto;
    }
  }
  .btn-primary {
    color: #fff;
  }

  .btn.btn-icon {
    text-decoration: none;
    &:hover, &:focus {
      text-decoration: none;
    }
  }

  .form-head {
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;
    @media only screen and (min-width: 1300px) {
      flex-direction: row;
      align-items: flex-end;
      justify-content: space-between;
    }

    > h1 {
      @media only screen and (min-width: 1300px) {
        margin: 0;
      }
    }
    .buttons {
      text-align: right;

      .vdp-datepicker__calendar {
        // right: 0;
      }
    }
  }
  .form-footer {
    text-align: right;
    margin-top: 1rem;

    .btn-primary {
      > div {
        display: inline-block;
      }
    }
  }
}

.card {
  border: 0;
  margin-bottom: 2rem;
  height: calc(100% - 2rem);
  border-radius: 5px;

  .card-header {
    background: #fff;
    color: #020202;
    font-weight: 600;
    text-transform: uppercase;
    border: 0;
    border-radius: 5px;
  }
  .card-body {
    background: #F1F2F2;
    border-radius: 5px;

    .list-group-item {
      border: 0;
      border-bottom: 1px solid #F1F2F2;
      margin-bottom: 0;

      &.no-account {
        background: #F1F2F2;
        padding: 0.75rem 0;
      }
    }
  }
}

.card-body {
  .table {
    background: #fff;
  }
  .general-ledger {
    .date {
      width: 10rem;
    }

    .debit, .credit {
      width: 8rem;
      text-align: right;
    }
    td {
      &:last-child, &:nth-last-child(2) {
        text-align: right;
      }
    }
  }
}

.pagination {
  margin-top: 2rem;

  .page-item.disabled .page-link {
    background: #f9f9f9;
    color: #ccc;
  }
}

.label {
  font-size: 0.90rem;
  font-weight: 600;
}

.fade-leave-active {
  transition: all .15s;
}
.fade-enter-active {
  transition: all .15s;
  transition-delay: 0.30s;
}
.fade-enter, .fade-leave-to {
  transform: translateX(50px);
  opacity: 0;
}

.fade-top-leave-active {
  transition: all .15s;
}
.fade-top-enter-active {
  transition: all .15s;
  transition-delay: 0.15s;
}
.fade-top-enter, .fade-top-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}

h1 {
  font-size: 2.25rem;
  color: #547F99;
  letter-spacing: -0.15rem;

  .btn {
    letter-spacing: 0;
  }
}

.alert-message {
  z-index: 2;
  position: sticky;
  top: 0;
  margin-bottom: 1.5rem;
  margin-left: -2.5rem;
  margin-right: -2.5rem;

  .syndicate-content & {
    margin-left: -1rem;
    margin-right: -1rem;

    @media only screen and (min-width: 992px){
      margin-left: -2rem;
      margin-right: -2rem;
    }
  }

  .alert {
    border-radius: 0;
    margin: 0;
    padding: 1rem 5rem;
    font-size: 1.5rem;
    text-align: center;

    &.alert-success {
      background:rgba(167,178,137, 0.8);
      border: 0;
      color: #fff;
    }
    &.alert-error {
      border: 0;
    }

    .close {
      top: 0.5rem;
    }
  }
}

.btn-outline-danger, .btn-outline-secondary {
  > svg, > svg > g {
    transition: fill ease 0.2s;
  }
  &:hover {
    > svg, > svg > g {
      fill: #fff;
    }
  }
}
.btn-danger, .btn-secondary {
  > svg {
    fill: #fff;
  }
  .delete-icon, .cancel-icon {
    fill: #fff!important;
  }
}
.float-btn-options {
  background: #fff;
  border: 1px solid #ddd;
  padding: 12px 14px;
  margin-right: 19px !important;
  border-radius: 10px;
  -webkit-box-shadow: 0px 0px 34px 3px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 34px 3px rgba(0, 0, 0, 0.2);
}
.btn-menu {
  margin-bottom: 1px;
}
.options {
  display: flex;
  margin: 10px !important;
  flex-direction: row;
}
.options button {
  border: none;
  cursor: pointer;
  /* margin-left: 5px; */
}
.floating-button {
  border: none;
  cursor: pointer;
  border-radius: 50%;
  box-shadow: none !important;
}
.toggle-options {
  display: flex;
  justify-content: center;
}
.btn-cog {
  background: #636363;
  border-radius: 50%;
  padding: 0rem;
  height: 55px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center ;
}
.float-btn {
  text-align: end;
  position: sticky;
  top: 25px;
  z-index: 9;
}
.coowner-user {
  overflow: visible !important;
    background-color: #e9ecef;
    cursor: not-allowed;
    opacity: 0.65;
    pointer-events: none;
}
span.select2-dropdown {
  width: max-content !important;
}
span.select2-selection.select2-selection--single {
  height: 30px;
}
span.select2.select2-container.select2-container--default.select2-container--above {
  width: 100%;
}
.transaction-filter {
  max-width: 200px;
}
.transaction-filter select{
  font-size: 0.875rem !important;
  padding: 0.25rem 0.5rem;
  height: 100%;
  min-width: 200px;
}
.options {
  display: flex;
  margin: 10px !important;
  flex-direction: row;
}
.options button {
  border: none;
  cursor: pointer;
  // margin-left: 5px;
}
.floating-button {
  border: none;
  cursor: pointer;
  border-radius: 50%;
  box-shadow: none !important;
}
.float-btn {
  text-align: end;
  position: sticky;
  top: 25px;
  z-index: 9;
}
.flot-budget {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  padding: 0.75rem 1rem;
  font-weight: 300;
  text-align: left;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
  font-size: 1rem;
  border-radius: 50%;
  align-items: baseline;
}
.toggle-options {
  display: flex;
  justify-content: center;
}
.btn-cog {
  background: #636363;
  border-radius: 50%;
  padding: 0rem;
  height: 55px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center ;
}
.budget-btn {
  box-shadow: rgba(0, 0, 0, 0.19) 0px 5px 15px 0px;
  border-radius: 10px;
  width: fit-content;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue